import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import Chip, { type ChipTone } from '../../components/Chip';
import type { BomAssessment } from '../../lib/types';

const VERDICTS: Readonly<Record<string, { label: string; tone: ChipTone }>> = {
  OFFEN: { label: 'Offen', tone: 'warn' },
  BETROFFEN: { label: 'Betroffen', tone: 'alert' },
  NICHT_BETROFFEN: { label: 'Nicht betroffen', tone: 'good' },
  BEHOBEN: { label: 'Behoben', tone: 'idle' },
};

interface Props {
  kevCves: readonly string[];
  assessments: readonly BomAssessment[];
  /** Text shown without findings; `null` renders nothing. */
  empty?: string | null;
}

/** KEV hits and assessed CVEs of one component version, each linked to the triage. */
export default function CveFindings({ kevCves, assessments, empty = 'Keine Befunde' }: Props): ReactNode {
  const verdicts = new Map(assessments.map((a) => [a.cve_id, a.verdict]));
  const cves = [...new Set([...kevCves, ...verdicts.keys()])].sort();
  if (cves.length === 0) return empty === null ? null : <span className="muted">{empty}</span>;
  return (
    <ul className="cve-findings">
      {cves.map((cve) => {
        const verdict = verdicts.get(cve);
        const shown = verdict ? VERDICTS[verdict] ?? { label: verdict, tone: 'neutral' as ChipTone } : null;
        return (
          <li key={cve}>
            <Link className="mono" to={`/triage?q=${encodeURIComponent(cve)}`} title="In der Triage öffnen"
              onClick={(event) => event.stopPropagation()}>{cve}</Link>
            {kevCves.includes(cve) ? <Chip tone="alert">KEV</Chip> : null}
            {shown ? <Chip tone={shown.tone}>{shown.label}</Chip> : <Chip>Nicht bewertet</Chip>}
          </li>
        );
      })}
    </ul>
  );
}
